import { render } from "./fastWestSoftCouponspayModel.vue?vue&type=template&id=f068362a"
import script from "./fastWestSoftCouponspayModel.vue?vue&type=script&lang=js"
export * from "./fastWestSoftCouponspayModel.vue?vue&type=script&lang=js"

import "./fastWestSoftCouponspayModel.vue?vue&type=style&index=0&id=f068362a&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__